import { render, staticRenderFns } from "./KiidsListTable.vue?vue&type=template&id=04bb85aa&scoped=true"
import script from "./KiidsListTable.vue?vue&type=script&lang=js"
export * from "./KiidsListTable.vue?vue&type=script&lang=js"
import style0 from "./KiidsListTable.vue?vue&type=style&index=0&id=04bb85aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb85aa",
  null
  
)

export default component.exports